var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("登陆GitHub")]),_c('h5',{staticClass:"subtitle"},[_vm._v("不登陆也可以用的哦")]),_c('a',{attrs:{"href":_vm.url}},[_vm._v("通过GitHub登陆")])])
}
var staticRenderFns = []

export { render, staticRenderFns }